import React, {useEffect,useState} from 'react';
import { NavLink ,useNavigate,useLocation} from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { usePage } from '../PageContext';
import { dynamicUrl,dynamicPageUrl } from './Function';
import { Container,Navbar,Offcanvas,Row,Col,Nav,Placeholder } from 'react-bootstrap';
export default function HeaderTop() 
{
    const { t, i18n } = useTranslation();
    const { page } = usePage();
    const navigate = useNavigate();
    const location = useLocation();
    const appTheme = ( localStorage.getItem('appTheme') === null ) ? 'light' : localStorage.getItem('appTheme');
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const [Theme, setTheme] = useState(appTheme);
    const [Language, setLanguage] = useState(appLanguage);
    const [fontSize, setFontSize] = useState(16);
    const [offcanvasVisible, setOffcanvasVisible] = useState(false);
    useEffect(() => 
    {
        document.body.style.fontSize = `${fontSize}px`;
        document.documentElement.setAttribute('data-bs-theme', Theme);
        document.documentElement.setAttribute('data-bs-language', Language);
        i18n.changeLanguage(Language);
    }, [fontSize,Theme,Language,i18n]);
    useEffect(() => {
        // Close Offcanvas on location change
        setOffcanvasVisible(false);
    }, [location]);
    const toggleOffcanvas = () => {
        setOffcanvasVisible(!offcanvasVisible);
    };
    const SkipToContent = (e) => 
    {
        e.preventDefault();
        const PageContent = document.getElementById('page-content');        
        const MainNavbar = document.getElementById('MainNavbar').offsetHeight * 2;
        const PageTitle = document.getElementById('page-title').offsetHeight * 2;       
        if (PageContent) 
        {
            PageContent.setAttribute('tabindex', '-1');
            PageContent.focus({ preventScroll: true });
            const topOffset = PageContent.offsetTop - MainNavbar - PageTitle - (location.pathname === '/' ? 0 : 15);
            window.scrollTo({
                top: topOffset,
                behavior: 'smooth'
            });
            if( global.config.IsPrint === false ) { console.info( PageContent.offsetTop+' - '+PageTitle+' + '+MainNavbar+' = '+topOffset ); }
            setTimeout(() => {
                PageContent.removeAttribute('tabindex');
            }, 500);
        }
    };
    const increaseFontSize = () => 
    {
        setFontSize((prevSize) => Math.min(20, prevSize + 2));
    };
    const decreaseFontSize = () => 
    { 
        setFontSize((prevSize) => Math.max(12, prevSize - 2));
    };
    function handleTheme()
    {
        if (Theme === 'light') 
        {
            localStorage.setItem('appTheme','dark');
            setTheme('dark');
        }
        else 
        {
            localStorage.setItem('appTheme','light');
            setTheme('light');
        }
    }
    function handleLanguage()
    {
        const pathname = location.pathname.replace('/frontend', '');
        const urlHas = pathname.split('/').filter(Boolean);
        if (Language === 'hi') 
        {
            
            if( window.confirm('यह आपको अंग्रेजी भाषा की ओर ले जाएगा। क्या आप निश्चित रूप से इस भाषा पर स्विच करना चाहते हैं?') )
            {
                localStorage.setItem('appLanguage','en');
                setLanguage('en');
                i18n.changeLanguage('en');
                if( page?.sp_id > 1 )
                {
                    navigate(dynamicPageUrl(page,'sp_htaccess'));
                }
                else
                {
                    if( decodeURIComponent(urlHas.at(0)) === 'घटनाक्रम' && decodeURIComponent(urlHas.at(1)) === 'विवरण' )
                    {
                        navigate(`/event/details/${page.se_htaccess}`);
                    }
                    else if( decodeURIComponent(urlHas.at(0)) === 'नोटिस' && decodeURIComponent(urlHas.at(1)) === 'विवरण' )
                    {
                        navigate(`/notice/details/${page.sn_htaccess}`);
                    }
                    else if( decodeURIComponent(urlHas.at(0)) === 'उपलब्धि' && decodeURIComponent(urlHas.at(1)) === 'विवरण' )
                    {
                        navigate(`/achievement/details/${page.sa_htaccess}`);
                    }
                    else if( decodeURIComponent(urlHas.at(0)) === 'परीक्षा' && decodeURIComponent(urlHas.at(1)) === 'विवरण' )
                    {
                        navigate(`/exam/details/${page.se_htaccess}`);
                    }
                    else if( decodeURIComponent(urlHas.at(0)) === 'प्रोफ़ाइल' && decodeURIComponent(urlHas.at(1)) === 'विवरण' )
                    {
                        navigate(`/profile/details/${page.su_htaccess}`);
                    }
                    else if( decodeURIComponent(urlHas.at(0)) === 'प्रोफ़ाइल' && decodeURIComponent(urlHas.at(1)) === 'प्रकाशन' )
                    {
                        navigate(`/profile/publications/${page.su_htaccess}`);
                    }
                    else if( decodeURIComponent(urlHas.at(0)) === 'क्लब-सोसायटी' && decodeURIComponent(urlHas.at(1)) === 'विवरण' )
                    {
                        navigate(`/clubs-societies/details/${page.sc_htaccess}`);
                    }
                    else if( decodeURIComponent(urlHas.at(0)) === 'झलकियाँ' && decodeURIComponent(urlHas.at(1)) === 'विवरण' )
                    {
                        navigate(`/glimpses/details/${page.sg_htaccess}`);
                    }
                    else if( decodeURIComponent(urlHas.at(0)) === 'प्रोग्राम' && decodeURIComponent(urlHas.at(1)) === 'विवरण' )
                    {
                        navigate(`/program/details/${page.p_htaccess}`);
                    }
                    else
                    {
                        window.location.reload();
                    }
                }
            }            
        }
        else 
        {
            if( window.confirm('This will lead you to हिन्दी language. Are you sure to switch to this language?') )
            {
                localStorage.setItem('appLanguage','hi');
                setLanguage('hi');
                i18n.changeLanguage('hi');
                if( page?.sp_id > 1 )
                {
                    navigate(dynamicPageUrl(page,'sp_htaccess_hi'));
                }
                else
                {
                    if( urlHas.at(0) === 'event' && urlHas.at(1) === 'details')
                    {
                        navigate(`/घटनाक्रम/विवरण/${page.se_htaccess_hi || page.se_htaccess}`);
                    }
                    else if(urlHas.at(0) === 'notice' && urlHas.at(1) === 'details')
                    {
                        navigate(`/नोटिस/विवरण/${page.sn_htaccess_hi || page.sn_htaccess}`);
                    }
                    else if( urlHas.at(0) === 'achievement' && urlHas.at(1) === 'details' )
                    {
                        navigate(`/उपलब्धि/विवरण/${page.sa_htaccess_hi || page.sa_htaccess}`);                        
                    }
                    else if( urlHas.at(0) === 'exam' && urlHas.at(1) === 'details' )
                    {
                        navigate(`/परीक्षा/विवरण/${page.se_htaccess_hi || page.se_htaccess}`);
                    }
                    else if( urlHas.at(0) === 'profile' && urlHas.at(1) === 'details' )
                    {
                        navigate(`/प्रोफ़ाइल/विवरण/${page.su_htaccess_hi || page.su_htaccess}`);
                    }
                    else if( urlHas.at(0) === 'profile' && urlHas.at(1) === 'publications' )
                    {
                        navigate(`/प्रोफ़ाइल/प्रकाशन/${page.su_htaccess_hi || page.su_htaccess}`);
                    }
                    else if( urlHas.at(0) === 'clubs-societies' && urlHas.at(1) === 'details' )
                    {
                        navigate(`/क्लब-सोसायटी/विवरण/${page.sc_htaccess_hi || page.sc_htaccess}`);
                    }
                    else if( urlHas.at(0) === 'glimpses' && urlHas.at(1) === 'details' )
                    {
                        navigate(`/झलकियाँ/विवरण/${page.sg_htaccess_hi || page.sg_htaccess}`);
                    }
                    else if( urlHas.at(0) === 'program' && urlHas.at(1) === 'details' )
                    {
                        navigate(`/प्रोग्राम/विवरण/${page.p_htaccess_hi || page.p_htaccess}`);        
                    }
                    else
                    {
                        window.location.reload();
                    }
                }
            }            
        }
    }
    return (        
        <div className="header-top bg-success">
            <Container>
                <Row className="align-items-center justify-content-between">
                    <Col xs="auto">
                        <Navbar className="p-0" key="lg" expand="lg">
                            <Navbar.Toggle aria-controls='topNav' onClick={toggleOffcanvas} />
                            <Navbar.Offcanvas id='topNav' aria-labelledby='topNav' backdrop={false} show={offcanvasVisible} onHide={() => setOffcanvasVisible(false)}>
                                <Offcanvas.Header closeButton>
                                    <Offcanvas.Title>{t('TopMenu')}</Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body className='bg-success'>
                                    <Nav as="ul" className="darknav" data-aos="flip-right" data-aos-duration="1500">
                                        <DynamicLink spId={145} setOffcanvasVisible={setOffcanvasVisible} />
                                        <DynamicLink spId={146} setOffcanvasVisible={setOffcanvasVisible} />
                                        <DynamicLink spId={174} setOffcanvasVisible={setOffcanvasVisible} />                                                     
                                        <DynamicLink spId={32} setOffcanvasVisible={setOffcanvasVisible} />
                                        <DynamicLink spId={203} setOffcanvasVisible={setOffcanvasVisible} />
                                        <DynamicLink spId={235} setOffcanvasVisible={setOffcanvasVisible} />
                                        <DynamicLink spId={356} setOffcanvasVisible={setOffcanvasVisible} />
                                        <DynamicLink spId={286} setOffcanvasVisible={setOffcanvasVisible} />
                                        <DynamicLink spId={373} setOffcanvasVisible={setOffcanvasVisible} />                                               
                                    </Nav>
                                </Offcanvas.Body>    
                            </Navbar.Offcanvas>
                        </Navbar>  
                    </Col>
                    <Col xs="auto" className='text-end'>
                        <Nav as="ul" className="d-inline-flex justify-content-end" data-aos="flip-left" data-aos-duration="1500">
                            <Nav.Item as="li">
                                <Nav.Link className="feature" onClick={SkipToContent} aria-label={t('SkipMain')}>
                                    <i className="bi bi-escape" style={{ transform: 'rotate(225deg)' }}></i>
                                </Nav.Link>
                            </Nav.Item>
                            <DynamicLink spId={225} setOffcanvasVisible={setOffcanvasVisible} />                            
                            <Nav.Item as="li">
                                <Nav.Link className="feature" onClick={increaseFontSize} disabled={fontSize === 20} aria-label={t('IncreaseFontLabel')}>{t('IncreaseFont')}</Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Nav.Link className="feature" onClick={decreaseFontSize} disabled={fontSize === 14} aria-label={t('DecreaseFontLabel')}>{t('DecreaseFont')}</Nav.Link>
                            </Nav.Item>                            
                            <Nav.Item as="li">
                                <Nav.Link onClick={() => handleTheme()} className="feature" aria-label={t('ThemeSwitcher')}>
                                    {Theme === 'light' ? <i className="bi bi-lightbulb"></i> : <i className="bi bi-lightbulb-fill"></i>}
                                </Nav.Link>
                            </Nav.Item>                            
                            <Nav.Item as="li">
                                <Nav.Link onClick={() => handleLanguage()} className="feature" aria-label={t('LanguageSwitcher')}>{t('Language')}</Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Nav.Link onClick={() => window.print()} className="feature" aria-label={t('PrintPage')}><i className="bi bi-printer-fill"></i></Nav.Link>
                            </Nav.Item>                         
                        </Nav>                                                               
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
const DynamicLink = ({spId, setOffcanvasVisible}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Links,setLinks]=useState([]);
    
    useEffect(()=>
    {
        const getDynamicLink = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"menu/MenuById/"+spId);
                const result = await response.json();
                setLinks(result);
                setLoading(false);
            
            } catch (error) 
            {
                console.error('DynamicLink : Error', error.message);
            }
        };
        getDynamicLink();    
    },[spId])
    return (
        <React.Fragment>
        {isLoading ? (
            <Nav.Item as="li">
                <Nav.Link style={(spId === 225) ? { width:"30px" } : { width:"70px" }} className={ spId === 225 ? 'feature' : null }>
                    <Placeholder xs={12} style={{minHeight:"0.6em"}} />
                </Nav.Link>
            </Nav.Item>
        ) : (
        <React.Fragment>
        {Links.map((sp,index)=>(
            <Nav.Item as="li" key={index}>
                <NavLink to={dynamicUrl(sp)} className={({ isActive }) => `${isActive ? 'active nav-link' : 'nav-link'} ${sp.sp_id === 225 ? 'feature' : ''}`} aria-label={appLanguage === 'hi' ? sp.sp_name_hi || sp.sp_name : sp.sp_name} onClick={() => setOffcanvasVisible(false)}>
                    {sp.sp_id === 225 ? <i className="bi bi-ear-fill"></i> : appLanguage === 'hi' ? sp.sp_name_hi || sp.sp_name : sp.sp_name }
                </NavLink>
            </Nav.Item>
        ))}
        </React.Fragment>
        )}
        </React.Fragment>
    );
}